const PHOTOS = [
  { src: "/images/clinic4.jpg", cap: "Play corner & growth chart" },
  { src: "/images/clinic1.jpg", cap: "Cartoon-friendly treatment room" },
  { src: "/images/clinic5.jpg", cap: "Reading & play area" },
  { src: "/images/clinic3.jpg", cap: "Our Malad West clinic" },
];

export const Gallery = () => (
  <section className="py-20" data-testid="gallery-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <span className="text-xs font-bold uppercase tracking-widest text-teal-600">Peek inside</span>
      <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">A clinic that feels like a playroom</h2>
    </div>
    <div className="mx-auto mt-10 grid max-w-7xl grid-cols-2 gap-4 px-6 md:grid-cols-4 lg:px-8">
      {PHOTOS.map((p, i) => (
        <figure key={p.src} data-testid={`gallery-photo-${i}`}
          className={`group relative overflow-hidden rounded-[1.75rem] ${i % 2 ? "md:mt-10" : ""}`}>
          <img src={p.src} alt={p.cap} className="aspect-[4/5] w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          <figcaption className="absolute inset-x-3 bottom-3 rounded-xl bg-white/90 px-3 py-2 text-xs font-bold text-slate-700 backdrop-blur">{p.cap}</figcaption>
        </figure>
      ))}
    </div>
  </section>
);
